import React from "react";
import { generateCRUDRoutes } from "../../../utils/index";

import { LaptopOutlined } from '@ant-design/icons';
import Accounts from "./index";
import ViewAccount from "./view";
import EditAccount from "./edit";
import employeeRoutes from "./employees/routes";
import farmRoutes from "./farms/routes";
import { MODULE_ACCOUNT } from "variables/constants";

const accountRoutes = [	
	generateCRUDRoutes({
		mainTitle: "Accounts",
		basePath: "accounts",
		mainComponent: <Accounts />,
	    layout: "/console",	   
	    icon: <LaptopOutlined className="h-6 w-6" />,
	    subTitle:"Account",
	    viewComponent: <ViewAccount />,
	    createComponent: <EditAccount />,
	    editComponent: <EditAccount />,
		level: 2,
		moduleId: MODULE_ACCOUNT,
		submodules: [
			
		]
	}),
	...farmRoutes,
	...employeeRoutes
]

export default accountRoutes;